import * as React from "react";
import {
  PapiAuthenticationConsumer,
  PapiClientProvider,
  PapiAuthenticationContextState,
  LoginResult,
  ActiveTradingAccountConsumer
} from "./Api/PapiClient";
import { LoginForm } from "./Login/LoginForm";
import { UsernamePassword } from "./Login/UsernamePassword";
import "./App.less";
import { PlatformLayout } from "./Platform/PlatformLayout";
import { IntlProvider } from "./Localisation/IntlProvider";
import { StoreProvider } from "./Store/StoreProvider";
import { Skeleton, Card, message, Switch, Form } from "antd";
import { PapiAuthenticationProviderWithSessionState } from "./Session/PapiProviderWithSession";
import { ActiveTradingAccountStreamingOpenPositionsWithTradesByMarketAndValueDateGrids } from "./Positions/ActiveTradingAccountStreamingOpenPositionsWithTradesByMarketAndValueDateGrids";
import { AccountSelector } from "./Account/AccountSelector";
import { ActiveTradingAccountStreamingResources } from "./TradingAccountResources/ActiveTradingAccountStreamingResources";
import { SpotFxActiveTradingAccountTradeHistory } from "./TradeHistory/SpotFx/ActiveTradingAccountSpotFxTradeHistory";
import { ActiveTradingAccountStatements } from "./Statements/ActiveTradingAccountStatements";
import { ProductType } from "swan-public-api-client";
import { useState } from "react";
import { ActiveTradingAccountStreamingOpenPositionsGrid } from "./Positions/ActiveTradingAccountStreamingOpenPositionsGrid";
import { ActiveTradingAccountStreamingOpenTradesGrid } from "./Trades/ActiveTradingAccountStreamingOpenTradesGrid";
import { ActiveTradingAccountTradeHistory } from "./TradeHistory/ActiveTradingAccountTradeHistory";

const papiUrl = process.env.REACT_APP_PAPI_URL as string;
const accountOperatorKey = process.env.REACT_APP_ACCOUNT_OPERATOR_KEY as string;

message.config({
  top: 32
});

const login = (papi: PapiAuthenticationContextState) => (
  request: UsernamePassword
): Promise<LoginResult> => {
  return papi.login(request.username, request.password, accountOperatorKey);
};

const App = () => {
  // todo: get default locale on startup from useragent or localstorage, inside the component

  const [aggregateOpenTrades, setAggregateOpenTrades] = useState(false);

  return (
    <StoreProvider>
      <PapiAuthenticationProviderWithSessionState url={papiUrl}>
        <IntlProvider>
          <PapiAuthenticationConsumer>
            {papi => {
              if (papi.isAuthenticated && papi.client) {
                return (
                  <PapiClientProvider client={papi.client}>
                    <ActiveTradingAccountConsumer>
                      {active => {
                        if (active.activeTradingAccount) {
                          return (
                            <PlatformLayout pages={[
                              {
                                key: "1",
                                navigationDetails: {
                                  title: "Positions",
                                  icon: "gold"
                                },
                                page: (
                                  <div>
                                    <ActiveTradingAccountStreamingResources className="platform-bar" bordered={false} />
                                    {
                                      active.activeTradingAccount.AccountType === ProductType.SpotFX
                                      ? <Card
                                          className="platform-card"
                                          bordered={false}
                                        >
                                          <ActiveTradingAccountStreamingOpenPositionsWithTradesByMarketAndValueDateGrids />
                                        </Card>
                                      : <Card
                                          className="platform-card"
                                          bordered={false}
                                          title="Positions"
                                          extra={
                                            <Form layout="inline">
                                              <Form.Item label="Aggregate">
                                                <Switch checked={aggregateOpenTrades} onChange={x => setAggregateOpenTrades(x)} />
                                              </Form.Item>
                                            </Form>
                                          }
                                        >
                                          {aggregateOpenTrades ? <ActiveTradingAccountStreamingOpenPositionsGrid /> : <ActiveTradingAccountStreamingOpenTradesGrid />}
                                        </Card>
                                    }
                                  </div>
                                )
                              },
                              {
                                key: "2",
                                navigationDetails: {
                                  title: "Trade History",
                                  icon: "history"
                                },
                                page: (
                                  <div>
                                    <ActiveTradingAccountStreamingResources className="platform-bar" bordered={false} />
                                    <Card className="platform-card" bordered={false} title="Trade History" >
                                      {active.activeTradingAccount.AccountType === ProductType.SpotFX
                                        ? <SpotFxActiveTradingAccountTradeHistory />
                                        : <ActiveTradingAccountTradeHistory />
                                      }
                                    </Card>
                                  </div>
                                )
                              },
                              {
                                key: "3",
                                navigationDetails: {
                                  title: "Statements",
                                  icon: "file-text"
                                },
                                page: (
                                  <Card className="platform-card" bordered={false} title="Statements" >
                                    <ActiveTradingAccountStatements />
                                  </Card>
                                )
                              }
                            ]} />
                          );
                        } else {
                          return (
                            <AccountSelector />
                          );
                        }
                      }}
                    </ActiveTradingAccountConsumer>
                  </PapiClientProvider>
                );
              } else {
                return papi.authenticationInProgress ? (
                  <Skeleton loading={true} />
                ) : (
                  <LoginForm onLogin={login(papi)} />
                );
              }
            }}
          </PapiAuthenticationConsumer>
        </IntlProvider>
      </PapiAuthenticationProviderWithSessionState>
    </StoreProvider>
  );
};

export default App;
